module.exports = __webpack_public_path__ + "img/choose-super-pass.bf7c72d9.svg";